(function (ng, window, doc, module) {

    var dependencies = ["ui.router", "ngSanitize", "ngAnimate", "ngMaterial", "ngMessages"];
    window.app = ng.module(module, dependencies);

    ng.element(doc).ready(function () {
        ng.bootstrap(doc, [module], { strictDi: true });
    });

})(window.angular, window, window.document, "auth"); // jshint ignore:line